import gql from 'graphql-tag'

export const getLabels = gql`
  query($labelName: String, $type: LabelType) {
    getLabels(
      labelName: $labelName,
      type: $type
    ) {
      id
      content
      color
      description
      createdAt
      updatedAt
      type
      deletable
    }
  }
`

export const newLabel = gql`
  mutation($labelInput: LabelInput!) {
    newLabel(
      labelInput: $labelInput
    ) {
      id
      content
      color
      description
    }
  }
`

export const editLabel = gql`
  mutation($labelInput: LabelInput!, $labelId: Int!) {
    editLabel(
      labelId: $labelId
      labelInput: $labelInput
    ) {
      id
      content
      color
      description
    }
  }
`

export const deleteLabelById = gql`
  mutation($labelId: Int!) {
    deleteLabelById(
      labelId: $labelId
    )
  }
`
